import React from "react";
import {CButton} from "@coreui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import {colors} from "../../../utils/theme";

const CloseButton = ({ onClick}) => {
  return(
    <>
      <CButton className="btn btn-sm btn-outline-danger" onClick={onClick} className="close-btn">
        <FontAwesomeIcon icon={faTimes} color={colors.status.failToDelivery}/>
      </CButton>
    </>
  )
}
export default CloseButton
